import React from 'react';
import { captureException } from '@/utils/sentry';
import { createStyles } from '@/contexts/theme-context';
import { Image, TouchableOpacity, View } from 'react-native';
import { shadow } from '@/styles';
import { useToasts } from '@/contexts/toast-context';

interface Props {
  imageURLs: string[];
  onPressImage?: (imageURL: string) => void;
}

export const ROW_HEIGHT = 32;

export const ImageRow: React.FC<Props> = ({ imageURLs, onPressImage }) => {
  const [styles] = useStyles();
  const { showErrorToast } = useToasts();

  return (
    <View style={styles.imageRow}>
      {imageURLs.map((url) => (
        <View key={url} style={styles.imageShadow}>
          <TouchableOpacity
            onPress={() => onPressImage?.(url)}
            testID="image-row-image"
          >
            <Image
              alt=""
              onError={(e) => {
                showErrorToast();
                captureException(e.nativeEvent.error);
              }}
              source={{ uri: url }}
              style={styles.image}
            />
          </TouchableOpacity>
        </View>
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  image: {
    height: ROW_HEIGHT,
    width: 24,
  },
  imageRow: {
    flexDirection: 'row',
  },
  imageShadow: {
    ...shadow({
      color: theme.colors.black,
      elevation: 1,
      opacity: 0.15,
      radius: 4,
      x: 0,
      y: 2,
    }),
    borderRadius: 4,
    marginLeft: 8,
  },
}));
